var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartDarkW18 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 1.002,
  d: "M14.71 4.041a3.553 3.553 0 0 0-5.026 0L9 4.726l-.685-.685a3.553 3.553 0 0 0-5.024 5.025l.684.685L9 14.775l5.025-5.024.684-.685a3.55 3.55 0 0 0 0-5.025Z"
})));
export default SvgIconHeartDarkW18;